/**
  * Automatic generated for gulp
  */
 export const project = 'personalapp';
 